<template>
  <div>
    <div class="public-table-but__left">
      <div class="item">
        <!-- <em>筛选：</em> -->
        <div class="item-wp">
          <div class="item-son" v-if="searchShow" >
            <el-select
              v-model="listParams.status"
              clearable
              placeholder="请选择状态"
              style="width: 180px"
            >
              <el-option label="正常" value="1"></el-option>
              <el-option label="禁用" value="0"></el-option>
            </el-select>
          </div>
          <div class="item-son" v-if="searchShow">
            <el-button  type="primary" @click="queryTableData"
              >查询 <i class="el-icon-search"></i>
            </el-button>
          </div>
          <div class="item-son" v-if="addShow">
            <el-button  type="primary" @click="handleClick('add')"
              >新增 <img src="@assets/images/add-icon.png" alt="" />
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="public-table-data">
      <el-table
        ref="multipleTable"
        size="medium"
        :data="tableData"
        border
        style="width: 100%"
        row-key="menuId"
        v-loading="loading"
      >
         <el-table-column
              align="center"
              fixed
              label="序号"
              type="index"
              width="100"
            >
              <template slot-scope="scope">
                <span>{{
                  (pages.pageNo - 1) * pages.pageSize + scope.$index + 1
                }}</span>
              </template>
            </el-table-column>

        <el-table-column prop="name" label="名称" align="center">
        </el-table-column>
        <el-table-column prop="icon" label="icon" width="200" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.icon" alt="" style="width: 20px; height: 20px"/>
          </template>
        </el-table-column>
        <el-table-column
          prop="paymentType"
          label="支付标识"
          width="120"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="paymentCode"
          label="支付编码"
          width="120"
          align="center"
        ></el-table-column>
        
        <!-- <el-table-column prop="color" label="文字色" width="120" align="center">
          <template slot-scope="scope">
            <div
              class="icon-width"
              :style="{ backgroundColor: scope.row.color }"
            ></div>
          </template>
        </el-table-column>

        <el-table-column
          prop="bgcolor"
          label="背景色"
          width="120"
          align="center"
        >
          <template slot-scope="scope">
            <div
              class="icon-width"
              :style="{ backgroundColor: scope.row.bgcolor }"
            ></div>
          </template>
        </el-table-column> -->

        <el-table-column prop="seq" label="排序" align="center">
        </el-table-column>

        <el-table-column v-if="userInfo && userInfo.operateStatus==1" prop="code" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <template v-if="numType">
              <el-switch
                  :disabled="statusShow"
                  v-model="scope.row.status"
                  :active-value="1"
                  :inactive-value="0"
                  @change="changeSwitch(scope.row)"
              >
              </el-switch>
            </template>
            <template v-else>
              <el-switch
                  :disabled="statusShow"
                  :value="scope.row.status"
                  :active-value="1"
                  :inactive-value="0"
                  @change="operationShowTime"
              >
              </el-switch>
            </template>

          </template>
        </el-table-column>

        <el-table-column v-if="deleteShow && editShow && userInfo && userInfo.operateStatus==1" label="操作" align="center" fixed="right" min-width="150">
          <template slot-scope="scope">
              <el-button
                  size="mini"
                  @click="handleClick('edit', scope.row)"
                  type="warning"
                  plain
                  v-if="editShow"
              >编辑</el-button
              >
              <el-button
                  size="mini"
                  @click="handleDelete(scope.row)"
                  type="primary"
                  plain
                  v-if="numType && deleteShow"
              >删除</el-button
              >
              <el-button
                  size="mini"
                  @click="operationShowTime"
                  type="primary"
                  plain
                  v-if="!numType && deleteShow"
              >删除</el-button
              >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 编辑弹框 -->
    <el-dialog
      title="新增/编辑支付类型"
      :visible.sync="dialogVisible"
      width="460px"
      :close-on-click-modal="false"
      class="public-dialog "
    >
      <div class="public-dialog-form xq_checkColor" >
        <el-form
          ref="ruleForm"
          :rules="rules"
          :model="params"
          label-width="80px"
        >
          <el-form-item label="名称" prop="name">
            <el-input
              placeholder="请填写支付类型名称"
              v-model="params.name"
            ></el-input>
          </el-form-item>

          <el-form-item label="标识" prop="paymentType">
            <el-input
              placeholder="请填写支付类型标识"
              v-model="params.paymentType"
              :disabled="clickType == 'edit' ? true : false"
            ></el-input>
          </el-form-item>
          <el-form-item label="编码" prop="paymentCode">
            <el-input
              placeholder="请填写支付类型标识"
              v-model="params.paymentCode"
            ></el-input>
          </el-form-item>
          <el-form-item label="icon">
            <!--图片部分-->
            <div class="screenshot">
              <span
                v-for="(imgUrl, index) in srcList"
                :key="index"
                class="slideshow"
              >
                <div
                  class="icon-close"
                  @click="removeUploading(index)"
                  v-if="isMoer"
                >
                  <i class="el-icon-close"></i>
                </div>
                <el-image
                  style="width: 85px; height: 85px; border-radius: 6px"
                  :src="imgUrl"
                  fit="cover"
                  @click="getPolicy"
                  v-loading="imgLoading"
                />
              </span>
              <div
                class="up-btn"
                style="width: 85px; height: 85px; line-height: 85px"
                @click="getPolicy"
                v-if="isMoer"
                v-loading="imgLoading"
              >
                <i class="el-icon-plus"></i>
              </div>
            </div>
            <input type="file" ref="file" @change="getFile" />
          </el-form-item>
            <!-- <el-form-item label="背景色" prop="bgcolor">
              <el-color-picker v-model="params.bgcolor"></el-color-picker>
            </el-form-item>
            <el-form-item label="文字色" prop="color">
              <el-color-picker v-model="params.color"></el-color-picker>
            </el-form-item> 
          <el-form-item label="说明" >
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              placeholder="请输入说明"
              v-model="params.descr"
            >
            </el-input>
          </el-form-item>-->

          <el-form-item label="排序" prop="seq">
            <el-input
              placeholder="请填写排序序号"
              v-model.number="params.seq"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
          >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
                   v-if="numType"
          >提 交</el-button
        >
        <el-button size="medium" type="primary" @click="operationShowTime"
                   v-else
        >提 交</el-button
        >
      </span>
    </el-dialog>
    <operation-confirmation  @closeOperation="publicMethios" :operationVisible="operationVisible"></operation-confirmation>
  </div>
</template>
<script>
import { PAGE_SIZE, FILE_ROOT, JOB_STATUS } from "@config";
import { ossUpload } from "@utils/filters/upload";
import { isEmpty } from "../../utils/tools";
import OperationConfirmation from "../../components/OperationConfirmation";
export default {
  components: {OperationConfirmation},
  data() {
    return {
      PAGE_SIZE,
      isEmpty,
      tableData: [],
      listParams: {},
      params: {},
      dialogVisible: false,
      total: 0,
      loading: false,
      clickType: "",
      pages: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      rules: {
        name: [
          { required: true, message: "请填写支付类型名称", trigger: "change" },
        ],
        paymentType: [
          { required: true, message: "请填写支付标识", trigger: "change" },
        ],
        paymentCode: [
          { required: true, message: "请填写支付编码", trigger: "change" },
        ],
        // bgcolor: [
        //   { required: true, message: "请填写背景色值", trigger: "change" },
        // ],
        // color: [
        //   { required: true, message: "请填写文字色值", trigger: "change" },
        // ],
        // descr: [{ required: true, message: "请填写简介", trigger: "change" }],
        seq: [
          // {  message: "请填写序号",  },
          { type: "number", message: "序号必须为数字值",trigger: "change"},
        ],
      },
      srcList: [],
      isMoer: true,
      imgLoading: false,
      operationVisible:false,
      numType:false,
      addShow: false,
      deleteShow: false,
      editShow: false,
      statusShow: true,
      searchShow: false,
    };
  },
  mounted() {
    if(window.sessionStorage.getItem('operationKey')){
      this.numType = true
    }
    this.queryTableData();
    this.getPermissionButtonList()
  },
  computed:{
    userInfo(){
      return this.$store.state.userInfo
    }
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
        this.srcList = [];
        this.isMoer = true;
      }
    },
  },
  methods: {
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'pay:type:query') {
            this.searchShow = true
          }
          if (item.code == 'pay:type:add') {
            this.addShow = true
          }
          if (item.code == "pay:type:delete") {
            this.deleteShow = true
          }
          if (item.code == "pay:type:edit") {
            this.editShow = true
          }
          if (item.code == "pay:type:status") {
            this.statusShow = false
          }
        })
      }
    },
    //清楚缓存数据，重启密码验证
    clearStore(){
      window.sessionStorage.removeItem('operationKey')
      this.numType = false
    },
    //关闭
    publicMethios(e){
      this.operationVisible = false
      if(e=='open'){
        this.numType = true
        setTimeout(()=>{
          window.sessionStorage.removeItem('operationKey')
          this.numType = false
        },300000)
      }
    },
    //调起字组件的操作密码框
    operationShowTime(e){
      this.operationVisible = true
    },
    /**
     * 获取列表
     */
    async queryTableData() {
      this.loading = true;

      const { data: resData } = await this.$get("/payment/type/list", {
        params: {
          ...this.listParams,
          ...this.pages,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;

      this.tableData = resData.data;
      this.tableData.sort((a, b) => {
        return b.seq - a.seq;
      });
    },
    /**
     * 修改支付类型状态
     */
    async changeSwitch(b) {
      const { data: resData } = await this.$put(
        `payment/type/info/status/${b.paymentType}`
      );
      // this.loading = false;
      if (resData.result != 200) return;
      this.$message.success('操作成功')
      this.clearStore()
    },

    /**
     * 表格按钮点击
     */
    async handleClick(type, row = {}) {
      this.clickType = type;
      this.dialogVisible = true;
      if (type == "edit") {
        //编辑
        const { data: resData } = await this.$get(
          `payment/type/info/${row.paymentType}`,
          {
            headers: {
              isLoading: true,
            },
          }
        );

        if (resData.result != 200) return;
        this.params = resData.data;

        if (!isEmpty(this.params.icon)) {
          this.srcList[0] = this.params.icon;
          this.isMoer = false;
        }
      }
      if (type == "add") {
        this.params = {};
      }
    },

    /**
     * 编辑/增加
     */
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认保存数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickType == "add" || this.clickType == "addNext") {
            const { data: resData } = await this.$post(
              "payment/type/info",
              this.params,
              {
                headers: {
                  isLoading: true,
                },
              }
            );

            if (resData.result != 200) return;

            this.queryTableData();

            this.dialogVisible = false;

            this.$message.success("添加成功!");
            this.params = {};
          } else {
            const { data: resData } = await this.$put(
              "payment/type/info",
              this.params,
              {
                headers: {
                  isLoading: true,
                },
              }
            );

            if (resData.result != 200) return;

            this.queryTableData();

            this.dialogVisible = false;

            this.$message.success("修改成功!");
          }
        });
      });
      this.clearStore()
    },

    /**
     * 删除
     */
    handleDelete(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const { data: resData } = await this.$delete(
          `payment/type/info/${row.paymentType}`,
          {
            headers: {
              isLoading: true,
            },
          }
        );
        if (resData.result != 200) return;
        this.$message.success("删除成功!");
        this.queryTableData();
      });
      this.clearStore()
    },

    /**
     * 阿里云OSS签名
     */
    getPolicy() {
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },
    async getFile() {
      this.imgLoading = true;
      const that = this;
      const { data: resData } = await this.$get("aliyun/oss/sign");
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
        that.$refs.file.files[0],
        resData.data,
        "one" //'more','one'
      );
      this.imgLoading = false;
      this.isMoer = false;
      this.srcList = addRoutes;
      this.params.icon = this.srcList[0];
    },
    removeUploading(index) {
      this.srcList.splice(index, 1);
    },
  },
};
</script>
<style lang="scss" scoped>
.icon-width {
  width: 20px;
  height: 20px;
  display: inline-block;
}
.screenshot {
  position: relative;
}

.xq_checkColor {
    ::v-deep .el-color-picker__trigger {
        width: 60px !important; 
        height: 60px !important;
    }
}
</style>